module.exports = __webpack_public_path__ + "Profile696x1024.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Profile696x1024.jpg
// module id = 847
// module chunks = 0